export default "__VITE_ASSET__7f831c7f__"